import { fromHtml } from 'hast-util-from-html';
import { removePosition } from 'unist-util-remove-position';

type FromHtmlArguments = Parameters<typeof fromHtml>;

/**
 * SSR-safe replacement for hast-util-from-html-isomorphic.
 *
 * The package browser entry creates DOMParser at module scope, which crashes
 * when Next evaluates a browser-conditioned bundle in the server runtime.
 */
export const fromHtmlIsomorphic = (
  value: FromHtmlArguments[0],
  options?: FromHtmlArguments[1],
): ReturnType<typeof fromHtml> => {
  const tree = fromHtml(value, options);

  removePosition(tree, { force: true });
  delete tree.data;

  return tree;
};
